module.exports = __webpack_public_path__ + "img/overview_btn.b4e32247.svg";